import {
  ShopShopReadModelType,
  type ShopShopReadModelType as ShopType
} from '@r/api/generated/client.schemas.ts';
import { isStepLogicType } from '@admin/types/workspace/logic.ts';

/** Boutique reward affichée uniquement sur les workspaces à paliers. */
export function isRewardShopInStepProgram(
  shopType: ShopType | undefined,
  logicType: string | undefined
): boolean {
  return shopType === ShopShopReadModelType.reward && isStepLogicType(logicType);
}
